import Autolinker from 'autolinker';
import DOMPurify from "dompurify";

const MEDICAL_QUESTIONNAIRE_KEYWORD = 'medical-questionnaire';
const PREP_MAINTENANCE_KEYWORD = 'prep-maintenance-questionnaire';

/**
 * Normalizes HTTP(S) URLs to use https:// while preserving other schemes
 * (mailto:, tel:, custom app protocols, etc). This avoids corrupting explicit
 * non-HTTP links while protecting against insecure http:// links. For strings
 * without a scheme, https:// is assumed.
 *
 * @param {string} url Raw URL string from Autolinker.
 * @returns {string} Sanitized URL with https:// enforced only for HTTP(S) links.
 */
const ensureHttps = (url) => {
  const trimmed = (url || '').trim();
  if (!trimmed) {
    return '';
  }
  if (/^https:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (/^http:\/\//i.test(trimmed)) {
    return trimmed.replace(/^http:\/\//i, 'https://');
  }
  if (/^[a-z][a-z0-9+\-.]*:/i.test(trimmed)) {
    // Already has a non-HTTP scheme; do not modify.
    return trimmed;
  }
  return `https://${trimmed}`;
};

const linkedText = (text) => {
  const clean = DOMPurify.sanitize(text);
  const linked = Autolinker.link(clean, { 
    newWindow: true,
    urls: { schemeMatches: true, wwwMatches: true, tldMatches: true },
    className: 'custom-link',
    replaceFn: (match) => {
      const url = ensureHttps(match.getAnchorHref());
      if (url.includes(MEDICAL_QUESTIONNAIRE_KEYWORD)) {
        const safeUrl = DOMPurify.sanitize(url);
        // HIPAA compliance: do not expose sensitive URLs directly in href
        return `<span class="custom-link secure-link" style="cursor: pointer;" data-url="${encodeURIComponent(safeUrl)}">Medical Questionnaire Link</span>`;
      }
      if (url.includes(PREP_MAINTENANCE_KEYWORD)) {
        const safeUrl = DOMPurify.sanitize(url);
        // HIPAA compliance: do not expose sensitive URLs directly in href
        return `<span class="custom-link secure-link" style="cursor: pointer;" data-url="${encodeURIComponent(safeUrl)}">Questionnaire Link</span>`;
      }
      // Let Autolinker handle all other cases
      return true;
    }
  });
  return linked;
}

export default linkedText;
